import React from "react";

const CalenderPrev = ({ _className, ...props }: any) => {
  return (
    <svg width={7} height={12} fill="none" {...props}>
      <path
        className={_className}
        fill="var(--color-icon-bright)"
        d="M.8 6c0-.467.18-.933.533-1.287L5.68.367a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .706L2.04 5.42a.82.82 0 0 0 0 1.16l4.346 4.347a.503.503 0 0 1 0 .706.503.503 0 0 1-.706 0L1.333 7.287A1.818 1.818 0 0 1 .8 6Z"
      />
    </svg>
  );
};

export default CalenderPrev;
